import React from 'react';
import { useTemplateMergeFields } from './useTemplateMergeFields';
import styles from './SendMessageStep.module.css';

export const MergeFields: React.FC = () => {
  const { mergeFields } = useTemplateMergeFields();

  return (
    <aside className={styles.mergeFields}>
      <h3>Personalization</h3>
      <p>Add dynamic fields to personalize your email or SMS:</p>
      {mergeFields.map(group => (
        <section key={group.category}>
          <h4>{group.category}</h4>
          <div>
            {group.entries.map(field => (
              <code key={field.value}>{field.value}</code>
            ))}
          </div>
        </section>
      ))}
    </aside>
  );
};
